import backgroundImg from './background.png';
import failedTextImg from './failed_text.png';
import './FailedDelivery.css';

/** «Провалена» on the failed-delivery plaque. */
export function FailedDelivery() {
  return (
    <div className="failed-delivery" aria-hidden>
      <img
        className="failed-delivery__background"
        src={backgroundImg}
        alt=""
        draggable={false}
      />
      <img
        className="failed-delivery__label"
        src={failedTextImg}
        alt="Провалена"
        draggable={false}
      />
    </div>
  );
}
